module.exports = "/_next/static/images/7035fc9292cf49f583e0628531c234a9-hero-md.jpg.webp";